/**
 * Wishlist (localStorage-based)
 * -------------------------------------------------
 * Stores product handles in localStorage under the key "wishlist".
 * Renders items into the #wishlist-items-list offcanvas (see wishlist-items.liquid)
 * and opens the shared offcanvas (#offcanvas-cart) when an item is added.
 */

function getWishlist() {
  return JSON.parse(localStorage.getItem('wishlist') || '[]');
}

function saveWishlist(handles) {
  localStorage.setItem('wishlist', JSON.stringify(handles));
}

// Used to avoid race conditions when renderWishlist() is called multiple
// times in quick succession (e.g. rapid clicking "add to wishlist").
let wishlistRenderToken = 0;

function openWishlistOffcanvas() {
  const el = document.getElementById('offcanvas-cart'); // shared ID with cart offcanvas
  if (!el) {
    console.warn('Wishlist offcanvas element not found in DOM.');
    return;
  }
  if (typeof bootstrap === 'undefined' || !bootstrap.Offcanvas) {
    console.warn('Bootstrap Offcanvas JS not loaded.');
    return;
  }
  const instance = bootstrap.Offcanvas.getOrCreateInstance(el);
  instance.show();
}

async function renderWishlist() {
  const list = document.getElementById('wishlist-items-list');
  const empty = document.getElementById('wishlist-empty');
  const template = document.getElementById('wishlist-item-template');

  if (!list || !template) {
    console.warn('Wishlist offcanvas markup not found — is wishlist_enable on?');
    return;
  }

  const myToken = ++wishlistRenderToken;

  const handles = getWishlist();
  list.innerHTML = '';

  if (handles.length === 0) {
    if (empty) empty.hidden = false;
    return;
  }
  if (empty) empty.hidden = true;

  for (const handle of handles) {
    try {
      const res = await fetch(`/products/${handle}.js`);

      // Abandon this render if a newer one has started since.
      if (myToken !== wishlistRenderToken) return;

      if (!res.ok) {
        console.warn('Product fetch failed for handle:', handle, res.status);
        continue;
      }

      const product = await res.json();

      if (myToken !== wishlistRenderToken) return;

      const clone = template.content.cloneNode(true);

      const image = clone.querySelector('.wishlist-item-image');
      if (image) {
        image.src = product.featured_image || '';
        image.alt = product.title;
      }

      clone.querySelectorAll('.wishlist-item-link').forEach((a) => {
        a.href = `/products/${product.handle}`;
      });

      const titleLink = clone.querySelector('.wishlist-item-product-title a');
      if (titleLink) titleLink.textContent = product.title;

      const variantEl = clone.querySelector('.wishlist-item-variant-title');
      if (variantEl) {
        if (product.variants && product.variants.length > 1) {
          variantEl.textContent = product.variants[0].title;
          variantEl.hidden = false;
        } else {
          variantEl.hidden = true;
        }
      }

      const removeBtn = clone.querySelector('[data-wishlist-remove]');
      if (removeBtn) removeBtn.dataset.handle = product.handle;

      list.appendChild(clone);
    } catch (err) {
      console.error('Wishlist item render error:', handle, err);
    }
  }
}

document.addEventListener('click', (e) => {
  const addBtn = e.target.closest('[data-wishlist-add]');
  if (addBtn) {
    e.preventDefault();

    const handle = (addBtn.dataset.productHandle || '').trim().toLowerCase();
    if (!handle) {
      console.warn('Wishlist button missing data-product-handle.');
      return;
    }

    const handles = getWishlist();
    if (!handles.includes(handle)) {
      handles.push(handle);
      saveWishlist(handles);
    }

    renderWishlist().then(openWishlistOffcanvas);
    return;
  }

  const removeBtn = e.target.closest('[data-wishlist-remove]');
  if (removeBtn) {
    const handle = (removeBtn.dataset.handle || '').trim().toLowerCase();
    const handles = getWishlist().filter((h) => h !== handle);
    saveWishlist(handles);
    renderWishlist();
  }
});

document.addEventListener('DOMContentLoaded', renderWishlist);